import { Css, useBreakpoint } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useBudgetOverviewTabQuery } from "src/routes/projects/budget/components/reports/BudgetOverviewTab.generated";
import { ProjectParams } from "src/routes/routesDef";
import { queryResult } from "src/utils";
import { AverageCommittedAtStartWidget } from "./widgets/AverageCommittedAtStartWidget";
import { AverageDirectMarginWidget } from "./widgets/AverageDirectMarginWidget";
import { AverageVarianceWidget } from "./widgets/AverageVarianceWidget";
import { CompletedTaskBudgetReviewWidget } from "./widgets/CompletedTaskBudgetReviewWidget";
import { VerticalCompleteBudgetStatusWidget } from "./widgets/VerticalCompleteBudgetStatusWidget";

export function BudgetOverviewTab() {
  const { projectId } = useRouteParams<ProjectParams>();
  const query = useBudgetOverviewTabQuery({ variables: { projectId } });
  const { mdAndDown } = useBreakpoint();

  return queryResult(query, ({ project }) => (
    <div>
      <div css={Css.w100.df.fdr.gap2.tac.mb3.if(mdAndDown).fdc.$}>
        <AverageDirectMarginWidget project={project} />
        <AverageVarianceWidget project={project} />
        <AverageCommittedAtStartWidget project={project} />
      </div>
      <div css={Css.w100.df.fdr.gap2.tac.if(mdAndDown).fdc.$}>
        <CompletedTaskBudgetReviewWidget />
        <VerticalCompleteBudgetStatusWidget project={project} />
      </div>
    </div>
  ));
}
